export const ParticipantOrganizationTypes = {
  nonGovernment: 'nonGovernment',
  subordinate: 'subordinate',
  company: 'company',
};



// WEBPACK FOOTER //
// ./src/models/auth/ParticipantOrganizationTypes.js